var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-card',[_c('p',[_c('i',{class:['tim-icons', _vm.icon]})]),_c('p',{staticStyle:{"margin-top":"20px"}},[_vm._v(_vm._s(_vm.text))])])}
var staticRenderFns = []

export { render, staticRenderFns }